import React, { useEffect, useState } from 'react';
import VehicleService from 'src/services/Vehicle.service';
import BrandAutocomplete, { createOption } from '.';

function VehicleAutoComplete({
  onChange,
  value,
  name,
  label,
  placeholder,
  createApiCall,
  deleteApiCall,
  deleteOnClear = false,
  noLabel = false,
  multiple = false,
  filter = {},
  pickKey = 'id'
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const { data = [] } = await VehicleService.get(filter);
      setOptions(data);
      // if (!multiple) setOptions(data);
      // else setOptions([createOption('All Vehicles', null), ...data]);
    })();
  }, []);
  return (
    <BrandAutocomplete
      label={label ?? 'Vehicle'}
      noLabel={noLabel}
      placeholder={placeholder || 'Select Vehicle...'}
      onChange={onChange}
      createApiCall={createApiCall}
      deleteApiCall={deleteApiCall}
      deleteOnClear={deleteOnClear}
      value={value}
      multiple={multiple}
      name={name ?? 'vehicle'}
      options={options?.map((el) => {
        return {
          label: `${el?.registrationNumber} (${el?.imei || 'Not linked'})`,
          value: el?.[pickKey]
        };
      })}
    />
  );
}

export default VehicleAutoComplete;
